import { Msg } from 'react-weui';
import TopNav from 'components/topNav.js';

function IpLimit() {
  return (
    <div>
      <TopNav inited={true} />
      <Msg
        type="warn"
        title="您当前选择的公司开启了IP地址限制功能，您现在的IP地址不在安全列表内。"
      />
    </div>
  );
}

export default IpLimit;
